import { Directive, inject, Injector, OnInit } from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import {
  OutputInfo,
  outputInfoStoreToken,
} from '../core/h3ml/state/output-info';
import { TaskWorkspaceStore } from '../core/h3ml/state/task-workspace-store';
import { Answer } from '../team-apis/otterdam/answers/answer';
import { AbstractOutput } from '../team-apis/otterdam/outputs/output';

@Directive()
export abstract class AbstractOutputComponent<
    O extends AbstractOutput,
    A extends Answer,
  >
  extends DirectiveSuperclass
  implements OnInit
{
  readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  outputInfoStore!: Store<OutputInfo<O, A>>;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // Done in ngOnInit instead of the constructor as a timing hack
    this.outputInfoStore =
      this.injector.get<Store<OutputInfo<O, A>>>(outputInfoStoreToken);
  }
}
